/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { getProjectKeyOrId } from '@jira/router-resources__utils/src/getProjectKeyOrId.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

export const senderNameResource: RouteResource<string> = createResource<string>({
	type: 'CSM_SENDER_NAME',
	getKey: (matchedRoute) => `sender-name-${getProjectKeyOrId(matchedRoute.match)}`,
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-sender-name", jiraSpaEntry: "async-resource-sender-name" */ './getData.tsx'
		),
});
